import { render, staticRenderFns } from "./ShipmentsMenuNew.vue?vue&type=template&id=37f1630c&scoped=true&"
import script from "./ShipmentsMenuNew.vue?vue&type=script&lang=ts&"
export * from "./ShipmentsMenuNew.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentsMenuNew.vue?vue&type=style&index=0&id=37f1630c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1630c",
  null
  
)

export default component.exports